<template>
  <Tabs value="consit">
    <TabPane label="疑问概况" name="consit" icon="ios-pie">
      <query-consist></query-consist>
    </TabPane>
    <TabPane label="类型状态交叉表" name="cross" icon="ios-close">

    </TabPane>
    <TabPane label="疑问时效" name="time" icon="ios-time">

    </TabPane>
    <TabPane label="各表单疑问汇总" name="form" icon="ios-list">

    </TabPane>
  </Tabs>
</template>

<script>
import QueryConsist from '@/components/stat/QueryConsist'

export default {
  name: 'query-stat',
  components: {
    'query-consist': QueryConsist
  }
}
</script>
